import { Controller } from "@hotwired/stimulus"
import { gsap } from "gsap"
import Lenis from "lenis"

export default class extends Controller {
	static outlets = ["flow"]

	static targets = [ "infoButton", "gallery", "info", "picture", "wrapper", "content" ]

	static values = {
		infoVisible: {
			type: Boolean,
			default: false
		}
	}

	connect() {
		gsap.fromTo(
			this.pictureTargets,
			{ opacity: 0 },
			{
				opacity: 1,
				duration: 1,
				stagger: 0.15,
				delay: 0.25,
				ease: "power4.out"
			}
		)
	}

	toggleInfo() {
		if (this.infoVisibleValue) {
			this.#hideInfo()
			this.infoVisibleValue = false
		} else {
			this.#showInfo()
			this.infoVisibleValue = true
		}
	}

	#showInfo() {
		this.infoButtonTarget.innerText = "Less Information"
		this.infoButtonTarget.dataset.active = true
		this.dispatch("showInfo")

		const timeline = gsap.timeline()
		timeline.to(this.galleryTarget, { opacity: 0, duration: 1, ease: "power4.out" })
		timeline.to(this.infoTarget, { opacity: 1, duration: 1, delay: 0.25, ease: "power4.in" }, "<")

		this.lenis = new Lenis({
			wrapper: this.wrapperTarget,
			content: this.contentTarget,
			eventsTarget: document.body,

			orientation: "vertical",
			// gestureOrientation: "both",
			infinite: false,

			duration: 1.2,
			easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),

			smoothWheel: true,
			wheelMultiplier: 1,      // Scroll speed multiplier
			touchMultiplier: 2,      // Touch scroll speed

			autoRaf: true
		})
	}

	#hideInfo() {
		this.infoButtonTarget.innerText = "More Information"
		delete this.infoButtonTarget.dataset.active
		this.dispatch("hideInfo")

		const timeline = gsap.timeline()
		timeline.to(this.infoTarget, { opacity: 0, duration: 1, ease: "power4.out" })
		timeline.to(this.galleryTarget, { opacity: 1, duration: 1, delay: 0.25, ease: "power4.in" }, "<")

		this.lenis.destroy()
		delete this.lenis
	}
}
